<template>
  <div class='particulars'>
    <div class="YTitle">{{`${data.title}详情`}}</div>

    <div class="main">
      <YHead></YHead>

      <YBillTemplate :fromList='fromList' v-if="fromList.length > 0" ref="YBillTemplate"></YBillTemplate>

      <YControlBtns @click='goback' :jobButtons='jobButtons' :jobAuditRecords='jobAuditRecords'></YControlBtns>
    </div>

    <YPrint :jobAuditRecords='jobAuditRecords' @close='YPrintClose' v-if="YPrintSHow">
      <YHead></YHead>

      <YBillTemplate :fromList='fromList' v-if="fromList.length > 0" ref="YBillTemplate"></YBillTemplate>
    </YPrint>
  </div>
</template>

<script>
import api from '@/shared/api/apps/requisition'
export default {
  name: 'particulars',

  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      content: '',
      YPrintSHow: false,
      fromList: [],
      jobInfo: {},
      jobButtons: [],
      jobAuditRecords: [],
      jobPreCopyInfoes: [],
      jobPreAuditInfoes: []
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getData()
    },

    getData () {
      const params = {
        method: api.flowJobGet,
        jobId: this.data.jobId
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_flow_flowJob_get_response.code !== '10000') return
        const form = JSON.parse(res.data.backend_odc_flow_flowJob_get_response.result.form)
        const formValue = JSON.parse(res.data.backend_odc_flow_flowJob_get_response.result.formValue)
        this.jobInfo = res.data.backend_odc_flow_flowJob_get_response.result.jobInfo
        this.jobButtons = res.data.backend_odc_flow_flowJob_get_response.result.jobButtons
        this.jobAuditRecords = res.data.backend_odc_flow_flowJob_get_response.result.jobAuditRecords
        this.jobPreCopyInfoes = res.data.backend_odc_flow_flowJob_get_response.result.jobPreCopyInfoes
        this.jobPreAuditInfoes = res.data.backend_odc_flow_flowJob_get_response.result.jobPreAuditInfoes
        form.forEach((res, index) => {
          formValue.forEach(res2 => {
            if (res.id === res2.id) {
              if (res.type === 'Form') {
                res.controls.fromList = res2.controls.fromList
              } else {
                if (!res2.controls.value) return
                res.controls.value = res2.controls.value
              }
            }
          })
        })
        if (this.jobInfo.status.type !== 0) {
          form.forEach(res => {
            res.controls.only = true
            if (res.controls.required) {
              res.controls.compile = false
            }
          })
        }
        this.fromList = form
      })
    },

    goback (val) {
      switch (val) {
        case 0:
          this.close()
          return ''
        case 1:
          this.submit(val)
          return ''
        case 2:
          this.submit(val)
          return ''
        case 3:
          this.submit(val)
          return ''
        case 4:
          this.submit(val)
          return ''
        case 5:
          this.submit(val)
          return ''
        case 6:
          this.submit(val)
          return ''
        case 7:
          this.$prompt('评论', {
            inputPlaceholder: '请输入评论内容',
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(({ value }) => {
            if (!value) return
            this.content = value
            this.submit(val)
          }).catch(() => {})
          return ''
        case 8:
          this.YPrintSHow = true
          return ''
      }
    },

    submit (val) {
      this.$refs.YBillTemplate.submitForm().then(res => {
        const params = {
          method: api.flowJobAudit,
          jobId: this.data.jobId,
          formValue: JSON.stringify(res),
          result: val
        }

        if (this.content) {
          params.content = this.content
        }

        this.axios.post(params).then(res => {
          if (res.data.backend_odc_flow_flowJob_audit_response.code !== '10000') return
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.content = ''
          if (val === 7) {
            this.getData()
          } else {
            this.close()
          }
        })
      })
    },

    close () {
      this.$emit('close')
    },

    YPrintClose () {
      this.YPrintSHow = false
    }
  }
}
</script>

<style lang='stylus' scoped>
  .particulars
    width 100%
    height 100%
    position absolute
    top 0
    left 0
    background #ffffff
    z-index 1
    display flex
    flex-direction column
    .main
      flex auto
      overflow auto
</style>
